import Immutable from 'immutable'
import { API_PARTNER_PROFILE } from '../actions/apiPartnerProfile'

const defaultState = Immutable.fromJS({
  status: 'UNINIT',
  partnerProfiles: []
})

export default (s, action) => {
  const state = s || defaultState
  switch (action.type) {
    case `${API_PARTNER_PROFILE}_REQUEST`:
    {
      return state.withMutations((st) => {
        st.set('status', 'PENDING')
        st.set('partnerProfiles', [])
        st.set('profile', '')
      })
    }

    case `${API_PARTNER_PROFILE}_SUCCESS`:
    {
      return state.withMutations((st) => {
        st.set('status', 'SUCCESS')
        st.set('profile', action.res.profile)
        st.set('partnerProfiles', action.res.partnerProfiles)
      })
    }

    case `${API_PARTNER_PROFILE}_FAILURE`:
    {
      return state.withMutations((st) => {
        st.set('status', 'FAILURE')
        st.set('partnerProfiles', [])
        st.set('profile', '')
        st.set('statusCode', action.error.status)
      })
    }

    default:
      return state
  }
}

// Selectors
export const getPartnerProfileSelector = ({ apiPartnerProfile }) => {
  return {
    status: apiPartnerProfile.get('status'),
    statusCode: apiPartnerProfile.get('statusCode'),
    profile: apiPartnerProfile.get('profile'),
    partnerProfiles: apiPartnerProfile.getIn(['partnerProfiles'])
  }
}
